import { z } from 'zod';
/**
 * Generic SSE envelope for LeanOpx streams. Phase 5 will add typed
 * discriminated unions for AI synthesis (`/api/ask`) and other long-
 * running streams; until then a generic `{ type, payload? }` covers
 * progress + error events.
 */
export const SseEvent = z.object({
    type: z.string(),
    payload: z.unknown().optional(),
});
